module.exports = __webpack_public_path__ + "img/ditu1_73568a43e.png";